import { ReactElement } from 'react';

import { MOBILE_WIDTH } from '@common/constants/MEDIAS';
import { css } from '@emotion/react';

import { palette } from '@lib/styles/palette';

export default function SkeletonEventList(): ReactElement {
  return (
    <ul css={skeletonEventListStyle}>
      {Array(10)
        .fill(null)
        .map((v, i) => (
          <div key={i} className="eventLi">
            <div className="eventImg">
              <div className="animationBar" />
            </div>
            <div className="eventDate" />
          </div>
        ))}
    </ul>
  );
}

const skeletonEventListStyle = css`
  padding: 17px 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 20px;
  position: relative;

  @media (max-width: ${MOBILE_WIDTH}) {
    display: block;
  }

  .eventLi {
    width: 100%;
    margin-bottom: 30px;
  }

  .eventImg {
    position: relative;
    aspect-ratio: 2.5;
    overflow: hidden;
    border-radius: 4px;
    background-color: ${palette.gray0};
  }

  .eventDate {
    width: 100%;
    height: 1rem;
    border-radius: 4px;
    background-color: ${palette.gray0};
    margin: 12px 0;
  }

  @keyframes loading {
    0% {
      transform: translateX(-30%);
    }
    50%,
    100% {
      transform: translateX(100%);
    }
  }

  .animationBar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      ${palette.gray0} 0%,
      #ffffffae 30%,
      ${palette.gray0} 60%
    );
    animation: loading 1.5s infinite linear;
  }
`;
